module.exports = __webpack_public_path__ + "static/media/hdl.9497ded0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/assessment/hdl.png
// module id = 2777
// module chunks = 0